import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ServicioService, StorageService } from '../../../servicios/index.service';
import {Observable} from 'rxjs';
declare var $;
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html'
})
export class MenuComponent implements OnInit {

  menu:boolean;
  @Input() datosGeolocation: any;
  @Input() visibleDatosMenu:boolean;
  @Input() btnCerarServ:boolean;
  btnCancelaServ:boolean;
  @Output() ubicServ:any = new EventEmitter;
  itemCancelaServ:any;
  cancelaServ:boolean;
  @Input() btnCancelar:boolean;
  @Output() marca:any = new EventEmitter;
  @Input() btnCancelarServAsig:any;
  @Input() datosUser:any;


  constructor( public _storage:StorageService, private _servicios:ServicioService ) {
    this.mostrar_menu();
    //this.itemCancelaServ = this._storage.consult_storage("rol");
  }

  ngOnInit() {

  }

  prueba( user:any ){
    console.log("Usuario", user);
  }

  mostrar_menu(){
    let st = this._storage.user_consult();

    if(st){
      this.menu = true;
    }else{
      this.menu = false;
    }
  }

  btn_cancelar(user:any){

    this.btnCancelar =false;
    let serv = this._storage.consult_storage("event_selec");
    $.notify({
      title:"<b>Servicio cancelado:</b><br>",
      message:"El servicio "+ serv + " fue cancelado"
    },{
      type: 'danger'
    });
    this._storage.elimina_st("event_selec");
    this.marca.emit({ "botonCancelar":false });
    if( user ){
      console.log(user);
      //this.datosGeolocation = false;
      //this.visibleDatosMenu = false;
      console.log(user.status);
      if( user.status !== 0 ){
        this._servicios.actServicio( user.$key ).subscribe(data=>{
          console.log("DAta", data);
        });
      }
    }
    //si tiene algo no acer cambios

  }

  crear_serv( lat:any, lng:any, user:any ){
    this.ubicServ.emit({'latServ':lat, 'lngServ':lng, 'user':user });
  }

  seguir(  ){

  }

  tab( user:any ){
    window.open("/#/seguimiento/"+ user);
  }

  cancelaServicio(user:any){
    this.btnCancelarServAsig = false;

    //$("#btn-crear-service").removeClass("hidden");
    console.log(user);
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/components/shared/menu/menu.component.ts